import Pagination from "@mui/material/Pagination";
import Box from "@mui/material/Box";
import {PaginationItem} from "@mui/material";
import Typography from "@mui/material/Typography";

import {NavigateFirstIcon, NavigateLastIcon, NavigateNextIcon, NavigatePreviousIcon} from "../../styles/icons";
import './CustomPagination.scss';

const CustomPagination = props => {
  const page = props.pageIndex + 1;
  const from = props.pageIndex * props.pageSize + 1;
  const to = Math.min((props.pageIndex + 1) * props.pageSize, props.count);
  return (
    <Box className="CustomPagination">
      <Typography>Showing {from} - {to} of {props.count}</Typography>
      <Pagination
        count={Math.ceil(props.count / props.pageSize)}
        onChange={(e,num) => props.onPageChange(e, num - 1)}
        page={page}
        defaultPage={page}
        rowsperpage={props.pageSize}
        rowsperpageoptions={[]}
        showFirstButton={props.showFirstButton === undefined ? true : props.showFirstButton}
        showLastButton={props.showLastButton === undefined ? true : props.showFirstButton}
        siblingCount={props.siblingCount ?? 0}
        boundaryCount={props.boundaryCount ?? 1}
        renderItem={(item) => (
          <PaginationItem {...item} slots={{
            first: NavigateFirstIcon,
            previous: NavigatePreviousIcon,
            next: NavigateNextIcon,
            last: NavigateLastIcon
          }}/>
        )}
        variant="outlined"
        shape="rounded"
      />
    </Box>
  );
};

export default CustomPagination;
